import React from 'react'
import ReactApexChart from 'react-apexcharts';

function PiChart({series=[20,40,30,10], title='Your Title', labels=['Lable A','Lable B','Lable C','Lable D']}) {
    const state = {
        series: series, //[44, 55, 13, 43],
        options: {
            title:{ text: title},
          chart: {
            width: 200,
            type: 'pie',
          },
          colors:['#028FD7', '#015681', '#001D2B','#4EB1E3'],
          labels: labels, // ['0% - 25%', '25% - 50%', '50% - 75%', '75% - 100%'],
          responsive: [{
            breakpoint: 480,
            options: {
              chart: {
                width: 180
              },
              legend: {
                position: 'bottom'
              }
            }
          }]
        },
      
      
      };

  return (
    
        <div style={{
                border: '1px solid #ccc',
                borderRadius: '5px',
                margin:'15px',
                minWidth:340}}>
              <ReactApexChart 
                options={state.options} 
                series={state.series}
                type="pie" 
              />
        </div>
   
  )
}

export default PiChart